//@flow

import React from "react"
import { FormattedMessage } from "react-intl"
import {
  RestrictionContainer,
  RestrictionLabel,
  RestrictionIcon,
  Slash
} from "./UI"
import SVGLoader from "../../UI/SVGLoader"

import iconATV from "../Icons/iconATV.svg"
import iconLeafBlower from "../Icons/iconLeafBlower.svg"
import iconWoodburning from "../Icons/iconWoodburning.svg"

import type { Restriction } from "./types"

const svgPathFor = (restriction: Restriction): string => {
  switch (restriction) {
    case "atv":
      return iconATV
    case "leafblower":
      return iconLeafBlower
    default:
      return iconWoodburning
  }
}

const RestrictionView = ({
  restriction,
  allowed
}: {
  restriction: Restriction,
  allowed: boolean
}) => (
  <RestrictionContainer>
    <RestrictionIcon allowed={allowed}>
      {!allowed && <Slash />}
      <SVGLoader
        path={svgPathFor(restriction)}
        height="100%"
        width="100%"
        fill="#000"
      />
    </RestrictionIcon>
    <RestrictionLabel>
      <FormattedMessage
        id={`kiosk.forecast.restrictions.${restriction}.${allowed
          ? "allowed"
          : "restricted"}`}
      />{" "}
    </RestrictionLabel>
  </RestrictionContainer>
)

export default RestrictionView



// WEBPACK FOOTER //
// ./src/Kiosk/CurrentAirQualityView/Restriction.js